var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandsHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "393.333px",
    height: "330px",
    viewBox: "328 218.823 393.333 330",
    enableBackground: "new 328 218.823 393.333 330",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 552,
    y: 241.333,
    width: 169.333,
    height: 307.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F57C67",
    d: "M700.036,242.104c-12.13,1.406-17.838,10.958-17.609,23.339c0.729,33.281-3.813,71.172-22.083,98.536 c-7.151,10.698-15.761,17.802-26.125,26.328l14.099-26.979c4.438-8.479,1.136-18.958-7.364-23.37 c-8.5-4.443-18.984-1.146-23.422,7.333l-42.672,81.667c-39.692,54.792-14.922,119.62-14.922,119.62l61.271,0.276 c0.308-31.297,19.604-57.984,19.604-57.984c86.276-101.151,79.917-199.282,79.37-224.407 C719.875,251.792,712.136,240.693,700.036,242.104"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 328,
    y: 241.333,
    width: 169.333,
    height: 307.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F57C67",
    d: "M348.739,242.104c12.141,1.406,17.834,10.958,17.6,23.339c-0.729,33.281,3.817,71.172,22.088,98.536 c7.151,10.698,15.761,17.802,26.125,26.328l-14.104-26.979c-4.433-8.479-1.146-18.958,7.369-23.37 c8.5-4.443,18.984-1.146,23.422,7.333l42.688,81.667c39.678,54.792,14.922,119.62,14.922,119.62l-61.286,0.276 c-0.308-31.297-19.604-57.984-19.604-57.984c-86.271-101.151-79.922-199.282-79.375-224.407 C328.896,251.792,336.646,240.693,348.739,242.104"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 432,
    y: 218.823,
    width: 176,
    height: 155.844
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE3224",
    d: "M607.958,267.302c0-26.792-21.744-48.511-48.594-48.511c-16.088,0-30.344,7.802-39.182,19.813 c-8.859-12.01-23.115-19.813-39.198-19.813c-26.833,0-48.599,21.719-48.599,48.511c0,12.953,5.104,24.719,13.406,33.417 l72.125,73.01l79.854-76.708C604.146,288.802,607.958,278.495,607.958,267.302"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(510.338818, 15.650058)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(584.539468, 15.650058)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(627.349341, 15.650058)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(668.792344, 15.650058)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.127978, 15.650058)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.30546, 15.650058)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.414801, 15.650058)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.127978, 45.07537)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.30546, 45.07537)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.414801, 45.07537)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsHeart);
export default __webpack_public_path__ + "static/media/hands_heart.c044a90a956d72b2e41eecd9c4ad2e93.svg";
export { ForwardRef as ReactComponent };